var map = {
	"./ic_accounts.png": 7652,
	"./ic_game.png": 6660,
	"./ic_others.png": 9790,
	"./ic_pacode.png": 6992,
	"./ic_payment.png": 1796,
	"./ic_tc.png": 7464
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6439;